export default {
  expressID: 'Platform Logistics Account',
  notAvailable: "Sorry, you don't have a  Logistics account, you can",
  applyOpening: 'Register',
  bindAccount: 'Bind an existing Logistics account',
  associateAccount:
    'Associate Logistics accounts opened or bound to other stores under this merchant',
  hint: "We don't support to change account or the bound at the moment. And the operation of changing is irreversible and unchangeable, please operate with caution.",
  registerAccount: 'Register A Logistics Account',
  accountType: 'Account Type',
  accountName: 'Account',
  password: 'Password',
  comfirmPassword: 'Confirm Password',
  phone: 'Phone',
  send: 'Get Verification Code',
  verifiCode: 'Verification Code',
  checkCode: 'Please check SMS',
  created: 'Register for me automatically (not recommended)',
  submit: 'Submit',
  bindFormTitle: 'Bind An Existing Logistics Account',
  binding: 'Bind',
  associateFormTitle: 'Associate To Logistics Accounts Of Other Stores',
  classify: 'Store Name / Logistics Account / Account Type',
  relevanceButton: 'Associate',
  logisticsPlat: 'Logistics Account',
  verifyPhone: 'Phone number',
  logisticsPlatAccount: 'Account Type',
  logisticsKey: 'API Key',
  perfeeSeller: 'Kilimall Seller',
  requiredTxtAccount: 'Please enter account',
  requiredTxtPassword: 'Please enter password',
  requiredTxtConfirmPassword: 'Please enter confirm password',
  requiredTxtPhone: 'Please enter phone number',
  requiredTxtVerifiCode: 'Please enter verification code',
  alsoCreateWmsAccount: 'Also create WMS account for me',
  passwordMustSame: 'The password input twice must be the same',
  wmsHiddenTxt:
    'Currently no public WMS independent panel, so the account password is not visible at the moment.',
  wmsAccount: 'WMS Account',
  notCreated: 'Not created',
  apply: 'Apply',
  applyWmsAccount: 'Apply For WMS Account',
  applyWmsAccountHint:
    'If you already have a XED logistics account, your application for a WMS account will be bound to this XED logistics account. If this XED logistics account is also associated with other stores, the WMS account will also be automatically associated with other stores after successful application, please confirm before executing the application.',
  phoneNumberZero: 'Please do not include the area code or numbers starting with zero',
  xedeliveryPassword: 'Logistics Password'
}
